export function fromApi({ id, name, value, isApproved }) {
    return ({
        id,
        label: name,
        value,
        isApproved,
    });
}